import logger from 'logger';

import { getAuthClient } from './clients';

type AuthUser = {
  id: string;
  firstName: string;
  lastName: string;
  name: string;
  email: string;
  phone: string | null;
  initials: string;
  creditInCents: number;
};

export async function resetPassword(input: {
  resetPasswordToken: string;
  password: string;
  passwordConfirmation: string;
}): Promise<
  | { ok: true; user: AuthUser }
  | {
      ok: false;
      reason: 'validation';
      fieldErrors: {
        resetPasswordToken?: string;
        password?: string;
        passwordConfirmation?: string;
      };
    }
  | { ok: false; reason: 'unknown' }
> {
  const client = getAuthClient();

  let res;
  try {
    res = await client.post<{
      success: boolean;
      data: AuthUser;
      error: {
        code: number | null;
        message: string | null;
        validation: Record<string, string[]> | null;
      };
    }>('/reset-password', {
      reset_password_token: input.resetPasswordToken,
      password: input.password,
      password_confirmation: input.passwordConfirmation,
    });
  } catch (err: any) {
    const status = err?.response?.status;
    if (status === 422) {
      const validation = err?.response?.data?.error?.validation ?? {};
      return {
        ok: false,
        reason: 'validation',
        fieldErrors: {
          resetPasswordToken: validation.resetPasswordToken?.[0],
          password: validation.password?.[0],
          passwordConfirmation: validation.passwordConfirmation?.[0],
        },
      };
    }
    logger.error({
      msg: 'ResetPasswordRequestFailed',
      noticable: err,
      extra: { context: { status } },
    });
    return { ok: false, reason: 'unknown' };
  }

  if (!res.data?.success || !res.data?.data) {
    logger.error({
      msg: 'ResetPasswordNonOkResponse',
      noticable: new Error('reset-password response did not include user data'),
    });
    return { ok: false, reason: 'unknown' };
  }

  return { ok: true, user: res.data.data };
}
